<template>
    <div class="template">
        <el-link style="margin-bottom:20px;" type="primary" @click="$downloadFile('QB_IMPORT_TEMPLATE_07042020.xlsx', qbTemplate)">Download Template</el-link>
        <el-form>
            <el-form-item size="medium">
                <el-upload action="" :auto-upload="false" :show-file-list="false" :file-list="fileList" :multiple="false" :limit="2" :on-change="onChange">
                    <el-input :value="filename" readonly style="width: 568px;">
                        <el-button slot="prepend" type="primary">Choose File</el-button>
                    </el-input>
                </el-upload>
            </el-form-item>

            <el-form-item size="medium">
                 <el-button :loading="loading" :disabled="loading" type="primary" @click="handleUpload">Upload</el-button>
                 <el-button style="float:right;" type="danger" plain @click="handleClear">Clear</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        fileList: [],
        filename: '',
        qbTemplate: process.env.VUE_APP_QB_TEMPLATE,
        loading: false
    }),
    methods: {
        onChange(files, fileList){
            this.fileList = [];
            this.fileList.push(files.raw);
            this.filename = files.name
        },
        handleClear(){
            this.fileList = []
            this.filename = ''
        },
        handleUpload(){
            if(this.fileList.length < 1 && !this.filename){
                this.$message({
                    type: 'error',
                    message: 'Please select file.'
                })
            }else{
                this.handleSubmit();
            }
        },
        async handleSubmit(){
            this.loading = true;
            try {
                let formData = new FormData();
                formData.append('myFile', this.fileList[0]);
                formData.append('user_id', JSON.parse(localStorage.getItem('user')).employee_id);
                formData.append('user_name', JSON.parse(localStorage.getItem('user')).user_name);
                formData.append('user_email', JSON.parse(localStorage.getItem('user')).email);
                let response = await this.$http.post('/quickbooks/upload', formData, {
                    headers: {
                        'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    }
                });
                if(response.status === 200){
                    this.$message({
                        type: 'success',
                        message: response.data.msg
                    })
                    this.loading = false;
                }
            } catch (error) {
                this.$message({
                    type: 'error',
                    message: error.data.msg
                })
                this.loading = false;
            }
        }
    }
}
</script>